import * as React from "react";
import { Image } from "react-native";

function Logo(props) {
  return (
    <Image
      source={require('./logo.png')}
      style={{ width: 90, height: 30 }}
    />
  );
}

export default Logo;
